import axios from "../../../../axios";
import Cookies from "js-cookie";

// API: Get Sent DashBoard Count
export const GetDashBoardData = async () => {
   const token = Cookies.get("employeeToken");

  return axios.post("/api/Jobs/GetDashboardData", {
    token,
  });
};
